import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortText'
})
export class ShortTextPipe implements PipeTransform {

  transform(value: string, len: number): string {
    if (value==null || value.length < len) return value;
    return value.substr(0, len) + "...";
  }

}
